module.exports = __webpack_public_path__ + "img/ic_export-completed.453ef1d0.svg";